export const environment = {
  production: true,
  isServer: true,
  version: 1.0,
  // for prerender

  host: 'https://henradealers.com',
  cdn: 'https://henradealers.com/uploads',
  api: 'https://henradealers.com/app',
  socket: 'https://peer.digitalgrid.pl',
  base: 'https://henradealers.com',
  name: 'Henra',
  currencies: ['EUR', 'PLN', 'GBP'],
  withavatar: false,
  events_exclude: [''],
  inpost_src: 'https://geowidget.inpost.pl/inpost-geowidget.js',
  inpost_css: 'https://geowidget.inpost.pl/inpost-geowidget.css',
  inpost: 'x'
};
